import { render, staticRenderFns } from "./UploadDataForm.vue?vue&type=template&id=21f205c1"
import script from "./UploadDataForm.vue?vue&type=script&lang=js"
export * from "./UploadDataForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports